import "../App.css";
import logo from "../imgs/Header.png";
import placeholder from "../imgs/placeholder.jpeg";
import rg from "../imgs/redemption-games.jpeg";
import cm from "../imgs/claw-machines.jpeg";
import tech from "../imgs/technical-support.jpeg";
import op from "../imgs/operations.jpg";
import rent from "../imgs/rent.png";

import Navbar from "../components/navbar"
import Warning from "../components/warning";
import Footer from "../components/footer";
import { Helmet } from "react-helmet";
import { useInView } from "react-intersection-observer";

document.fonts.ready.then(() => {
  document.body.classList.add("fonts-loaded");
});

const FadeInTitle = ({ children }) => {
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.2 });

  return (
    <p ref={ref} className={`fade-in Sector Concert Center Cyan ${inView ? "visible" : ""}`}>
      {children}
    </p>
  );
};

const FadeInTitleSplit = ({ children }) => {
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.2 });

  return (
    <p ref={ref} className={`fade-in Sector Concert Center Cyan Split MobileTextWidthFix ${inView ? "visible" : ""}`}>
      {children}
    </p>
  );
};

const Home = () => {
  return (
    <div className="App">
      <Helmet>
        <title>Heartland Fun</title>
        <meta name="title" content="Heartland Fun" />
        <meta name="description" content="Heartland Fun Amusement offers a variety of arcade equipment to create unforgettable experiences for your business with easy, hassle-free purchasing." />
        <meta name="keywords" content="Arcade equipment, Claw machines, Gaming systems, Amusement supplier, Business entertainment, Arcade experience, Hassle-free purchasing, Entertainment solutions, Fun equipment, Gaming for businesses" />
        <meta name="robots" content="index, follow" />
        <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
        <meta name="language" content="English" />
        <meta property="og:title" content="Heartland Fun" />
        <meta property="og:type" content="website" />
        <meta property="og:description " content="Heartland Fun Amusement offers a variety of arcade equipment to create unforgettable experiences for your business with easy, hassle-free purchasing." />
        <meta property="og:determiner " content="" />
        <meta property="og:url" content="https://heartland.csfrederick.com/" />
        <meta property="og:image" content="https://heartland.csfrederick.com/Header.png" />
        <meta property="og:image:secure_url" content="https://heartland.csfrederick.com/Header.png" />
        <link rel="icon" href="/favicon.ico" />
      </Helmet>
      <Navbar></Navbar>
      <Warning></Warning>
      <div className="HeadParent">
        <div className="HeadChildLeft">
          <p className="Brand Bungee Center Cyan BlurBackCyan">HEARTLAND FUN</p>
          <br></br>
          <p className="BrandSm Bungee Center Red BlurBackRed">AMUSEMENT SUPPLIER</p>
        </div>
        <div className="HeadChildCenter"></div>
        <div className="HeadChildRight">
          <img alt="Arcade Game Store Home Screen Logo" src={logo} className="HeadLogo"></img>
        </div>
      </div>
      <div className="Brake"></div>
      <FadeInTitle>WHO WE ARE</FadeInTitle>
      <p className="Blue InfoText Titillium Center FadeIn">
        Looking to add some fun and excitement to your arcade or business? Look no further than Heartland Fun Amusement Supplier! We are the ultimate destination for all your arcade equipment needs. We offer a wide range of equipment, from classic claw machines to cutting-edge gaming systems,  to help you create an  unforgettable gaming experience for your customers. Our hassle-free purchasing process makes it easy for you to bring the thrill of the arcade to your doorstep. Get in touch with us today and let's make your entertainment dreams a reality!
      </p>
      <a href="tel:7858137921" className="Button Titillium Center">
        Call Now!
      </a>
      <div className="Brake"></div>
      <div className="Parent">
        <div>
          <FadeInTitleSplit>
            A LITTLE SOMETHING FOR EVERYONE
          </FadeInTitleSplit>
        </div>
        <div className="Table">
          <div className="Container">
            <img alt="Arcade Games" src={placeholder} className="ProductHolder"></img>
            <a href="/games#KiddieRides" className="SmallButton">Kiddie Rides</a>
          </div>
          <div className="Container">
            <img alt="Arcade Games" src={rg} className="ProductHolder"></img>
            <a href="/games#RedemptionGames" className="SmallButton">Redemption Games</a>
          </div>
          <div className="Container">
            <img alt="Arcade Games" src={cm} className="ProductHolder"></img>
            <a href="/games#ClawMachines" className="SmallButton">Claw Machines</a>
          </div>
        </div>
      </div>
      <div className="Brake"></div>
      <FadeInTitle>TECHNICAL SUPPORT</FadeInTitle>
      <br></br>
      <div className="Parent">
        <div className="Container">
          <img alt="Technical Support" src={tech} className="ProductHolder MoreWidth"></img>
        </div>
        <p className="Blue InfoText Titillium Center Split MobileTextWidthFix FadeIn">
          Looking for trustworthy arcade machine services? Our team of professionals is here to offer you the best arcade experience. We can assist you with machine operations, sales, or technical support. Let's get your arcade game up and running!
        </p>
      </div>
      <a href="tel:7858137921" className="Button Titillium Center">
        Talk to a Technical Specialist
      </a>
      <div className="Brake"></div>
      <FadeInTitle>EVENT RENTAL</FadeInTitle>
      <br></br>
      <div className="Parent">
        <p className="Blue InfoText Titillium Center Split MobileTextWidthFix FadeIn">
          Are you planning a special event, like a birthday party, festival or any big gathering? Don't worry about the arcade games, we have got you covered! Our event rentals service offers a wide range of arcade games that are sure to entertain your guests and make your event a success.
        </p>

        <div className="Container">
          <img alt="Rental" src={rent} className="ProductHolder MoreWidth"></img>
        </div>

      </div>
      <a href="tel:7858137921" className="Button Titillium Center">
        Free Event Estimate
      </a>
      <div className="Brake"></div>
      <FadeInTitle>OPERATIONS</FadeInTitle>
      <br></br>
      <div className="Parent">
        <div className="Container">
          <img alt="Operations" src={op} className="ProductHolder MoreWidth"></img>
        </div>
        <p className="Blue InfoText Titillium Center Split MobileTextWidthFix FadeIn">
          Get ready to add some excitement to your business with our arcade machines. Our operations program is tailored to benefit businesses like yours. We offer a free examination of your business foot traffic to confirm if you meet our requirements. Get in touch with us today to know more.
        </p>
      </div>
      <a href="tel:7858137921" className="Button Titillium Center">
        Get a Free Estimate
      </a>
      <Footer></Footer>
    </div>
  );
};

export default Home;
